"use client";

import { TextResources } from "@portal/assets/text/TextResources";
import StatusBar from "@portal/components/atoms/statusBar";
import Typography from "@portal/components/atoms/v2/typography";
import useAmlVerified from "@portal/hooks/useAmlVerified";
import Link from "next/link";

const LimitedAccessMessage = () => {
  const { amlVerified, renewSoon, loading: amlLoading } = useAmlVerified();

  return (
    <>
      {!amlVerified && !amlLoading && (
        <div className="print:hidden">
          <StatusBar>
            <div className="flex">
              <Typography variant="Body">
                {TextResources.ADVISOR_MESSAGE_AML_NOT_VERIFIED}
                <Link href="/aml/form" className="text-blueHighlighted underline ml-2">
                  {TextResources.ADVISOR_MESSAGE_AML_NOT_VERIFIED_LINK}
                </Link>
              </Typography>
            </div>
          </StatusBar>
        </div>
      )}
      {renewSoon && !amlLoading && (
        <div className="print:hidden">
          <StatusBar>
            <div className="flex">
              <Typography variant="Body">
                {TextResources.MESSAGE_AML_EXPIRES_SOON}
                <Link href="/aml/form" className="text-blueHighlighted underline ml-2">
                  {TextResources.MESSAGE_AML_EXPIRES_SOON_LINK}
                </Link>
              </Typography>
            </div>
          </StatusBar>
        </div>
      )}
    </>
  );
};

export default LimitedAccessMessage;
